/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("../create/CreateQuestionComponent");
const _ = require("lodash");

class CloneAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        DeviceEntity,
        userSession,
        activeView,
        CustomFieldsEntity
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceEntity = new DeviceEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;

        this.userSession = userSession;
        this._CustomFieldsEntityDef = CustomFieldsEntity;

        this._firstRun = true;

        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        if (this._activeView) {
            if (this._activeView.pagingFeed) {
                this._selectedDevice = this._activeView.pagingFeed.getDeviceEntityById(
                    this._activeView.selectedRows[0]
                );
            } else {
                // TODO Support of legacy grid for Config Drift to be removed once migrated to entity grid
                this._selectedDeviceId = this._activeView.getSelectedDeviceIds()[0];
                this._selectedDevice = this._gameEditor.getDeviceEntityById(this._selectedDeviceId);
            }
        }

        this._deviceEntity.setName(this._selectedDevice.name.trim() + "-1");
        this._deviceEntity.setDescription(this._selectedDevice.description);
        this._deviceEntity.setConnectionInformation(
            this._selectedDevice.connectionInformation || {}
        );
        this._deviceEntity.setConnectionMethod(
            this._selectedDevice.connectionMethod || "cliConnection"
        );
        this._deviceEntity.setDiscoveryStatus("UNKNOWN");
        this._deviceEntity.setManagementState(this._selectedDevice.managementState);
        this._deviceEntity.setEnvironment(this._selectedDevice.environment);
        this._deviceEntity.setVrf(this._selectedDevice.vrf);
        this._deviceEntity.setUseIssu(this._selectedDevice.useIssu);
        this._deviceEntity.setLockEngine(this._selectedDevice.lockEngine);

        this._deviceEntity.setDiscoveryLevelFrom(this._selectedDevice.discoveryLevelFrom);
        this._deviceEntity.setDiscoveryLevel(this._selectedDevice.discoveryLevel);

        if (!_.isEmpty(this._selectedDevice.detectedTypeBase)) {
            this._deviceEntity.detectedTypeBase = this._selectedDevice.detectedTypeBase;
        }

        const engineZoneId = this._selectedDevice.engineZoneId;
        if (engineZoneId) {
            this._deviceEntity.setEngineZoneRelationship(engineZoneId);
        }

        const siteId = this._selectedDevice.siteId;
        if (_.isEmpty(siteId) || siteId === "/") {
            // this._deviceEntity.setSiteSetByUser(false);
        } else {
            // this._deviceEntity.setSiteSetByUser(this._selectedDevice.siteSetByUser);
            this._deviceEntity.setSiteRelationship(siteId);
        }

        return this._CustomFieldsEntityDef
            .loadColumnDefinitions(this.userSession.activeOrganization.id)
            .then((customFieldColumns) => {
                let customFields = {};
                if (this._selectedDevice.customFieldValues) {
                    Object.keys(customFieldColumns).forEach((key) => {
                        if (customFieldColumns[key].systemOwned === false) {
                            if (!this._selectedDevice.customFieldSources[key]) {
                                customFields[key] = this._selectedDevice.customFieldValues[key];
                            }
                        } else {
                            customFields[key] = _.get(customFieldColumns[key], "default", null);
                        }
                    });
                }
                this._deviceEntity.customFieldValues = customFields;
                return this._selectedDevice
                    .loadRelatedImageServer({id: true})
                    .then((imageServerEntity) => {
                        if (imageServerEntity) {
                            if (imageServerEntity.id) {
                                this._deviceEntity.setImageServerRelationship(imageServerEntity.id);
                            }
                        }
                        return this.cloneDevice();
                    })
                    .then(() => this.copyEdpValues());
            })
            .catch(this.cloneErrorHandler);
    }

    cloneErrorHandler(err) {
        if (err.userRejected) {
            return this._modalUserFeedback.hideDisplayed();
        }
        const errorCode = err && err.errorCode;
        this._logger.warn({error: err}, "Clone action error.");

        switch (errorCode) {
            case "EntityAlreadyExists":
                if (this._firstRun) {
                    this._firstRun = false;
                    return this.requestDeviceName(false);
                }
                return this.requestDeviceName(true);
            case "ExceededDeviceCount":
            /* falls through */
            default:
                return this.showError(err);
        }
    }

    launchDeviceEditor(id, name) {
        if (!id) {
            throw "Device creation error, invalid device id.";
        }
        let editorState = {
            fqn: Registrations.DIE_VIEW_DETAILS,
            viewState: {createMode: true},
        };
        let launchOpts = {id: id, title: name};
        return this._gameEditor.launchDeviceEditor(editorState, launchOpts);
    }

    cloneDevice() {
        let newItemId;
        return this._deviceEntity
            .create()
            .then((result) => {
                newItemId = result.id;
                return this._modalUserFeedback.hideDisplayed().then(() => {
                    return this.launchDeviceEditor(result.id, result.properties.name);
                });
            })
            .then(() => {
                if (typeof this._activeView.resetSelection === "function") {
                    // making a small delay, to be sure the grid is updated with new item
                    _.delay(() => this._activeView.resetSelection([newItemId]), 200);
                }
                return Promise.resolve(this);
            });
    }

    requestDeviceName(isNotUniq) {
        this._modalUserFeedback
            .displayCustom(
                new CreateQuestionComponent(
                    this._logger,
                    undefined,
                    undefined,
                    "Clone device",
                    isNotUniq
                        ? "The entered name is not unique. Please specify a unique name for this cloned device."
                        : "Please specify a unique name for this cloned device."
                ),
                {dontHide: true}
            )
            .then((result) => {
                return this._modalUserFeedback
                    .displayLoading()
                    .then(() => {
                        this._deviceEntity.name = result.name.trim();
                        return this.cloneDevice();
                    })
                    .then(() => this.copyEdpValues());
            })
            .catch(this.cloneErrorHandler);
    }

    showError(error) {
        return this._modalUserFeedback.displayError({error}).catch((error) => {
            if (error.userRejected) {
                return;
            }
            this._logger.warn({error}, "Clone action error.");
        });
    }

    async copyEdpValues() {
        const [newEdpEntities, edpDataEntities] = await Promise.all([
            this._deviceEntity.loadRelatedEdpData({enabled: true}),
            this._selectedDevice.loadRelatedEdpData({enabled: true}),
        ]);

        if (!Array.isArray(newEdpEntities) || !Array.isArray(edpDataEntities)) {
            throw new Error("Failed to load extended properties.");
        }

        for (const edpDataEntity of edpDataEntities) {
            const currentNewEdpEntity = newEdpEntities.find(
                (i) => i.getExtensionType() === edpDataEntity.getExtensionType()
            );
            if (currentNewEdpEntity) {
                currentNewEdpEntity.setEdpInstance(edpDataEntity.getEdpInstance());
                if (currentNewEdpEntity.isDirty()) {
                    await currentNewEdpEntity.update();
                }
            }
        }
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.entities.CustomFields",
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone device",
    shown: true,
    order: 5,
};
